export class PlatformAdapter {
    constructor() {
        this.config = null;
        this.serviceCache = new Map();
    }
    async loadServiceModule(serviceName) {
        // Base implementation for loading service modules
        // Subclasses will override this with platform-specific logic
        throw new Error(`Service ${serviceName} not implemented for this platform`);
    }
    validateConfig(config) {
        if (!config.projectId) {
            throw new Error('FirebaseKit: projectId is required');
        }
        // Additional validation can be added here
    }
}
//# sourceMappingURL=platform-adapter.js.map